<template>
  <el-card class="dashboard-card">
    <template #header>
      <slot name="header"></slot>
    </template>
    <slot name="body"></slot>
  </el-card>
</template>

<script>
  export default {
    name: "card-template-v2",
    props: ["classCustom", "styleObject", "effect"]
  };
</script>

<style scoped>
  .dashboard-card {
    height: 100%;
  }
</style>



// WEBPACK FOOTER //
// src/views/common/layout/card-template-v2.vue